export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dark%20cinematic%20theater%20interior%20with%20rich%20warm%20golden%20and%20amber%20lighting%2C%20elegant%20velvet%20curtains%20in%20deep%20crimson%2C%20soft%20spotlights%20creating%20dramatic%20atmosphere%2C%20movie%20premium%20cinema%20aesthetic%2C%20no%20people%2C%20abstract%20and%20artistic%20mood%2C%20clean%20composition&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="丁香花影院 - 沉浸式观影体验"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 backdrop-blur-sm border border-primary-500/30 mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-sm font-medium text-primary-300 whitespace-nowrap">每日更新 · 高清流畅</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
              丁香花影院
              <br />
              <span className="text-primary-400">你的专属在线追剧平台</span>
            </h1>

            <p className="text-lg md:text-xl text-white/60 mb-5 max-w-xl mx-auto lg:mx-0 font-light leading-relaxed">
              高清电影 · 热播剧集 · 综艺动漫 · 纪录片
            </p>

            <p className="text-base md:text-lg text-white/70 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              丁香花影院作为稳定可靠的在线影院平台，聚合全网优质影视资源，覆盖电影、电视剧、综艺、动漫等全品类内容。每日同步更新最新影片，多重CDN加速保障流畅观影体验，无需注册、全程免费、纯净无广告。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white font-heading">5万+</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">影视资源</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white font-heading">每日更新</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">追剧不等待</div>
              </div>
              <div className="w-px h-10 bg-white/20 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-white font-heading">纯净安全</div>
                <div className="text-xs md:text-sm text-white/50 mt-1">无广告无弹窗</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all whitespace-nowrap cursor-pointer text-base"
              >
                <i className="ri-play-circle-line text-xl"></i>
                开始观影
              </a>
              <a
                href="#features"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white font-medium rounded-full border border-white/30 transition-all whitespace-nowrap cursor-pointer text-base backdrop-blur-sm"
              >
                <i className="ri-information-line text-xl"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:flex items-center justify-center">
            <div className="relative w-full max-w-[500px] aspect-[4/5]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20elegant%20cinema%20visual%2C%20abstract%20geometric%20film%20reel%20and%20light%20beam%20composition%2C%20warm%20golden%20and%20amber%20gradients%2C%20minimalist%20design%20aesthetic%2C%20soft%20glow%20effects%2C%20cinematic%20atmosphere%2C%20clean%20and%20modern%20composition%20on%20dark%20background&width=600&height=750&seq=hero-visual-01&orientation=portrait"
                alt="丁香花影院 - 高清流畅观影"
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute -bottom-4 -right-4 bg-background-50/10 backdrop-blur-md rounded-2xl p-4 border border-white/20 hidden xl:block">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary-500 flex items-center justify-center">
                    <i className="ri-play-fill text-white text-lg"></i>
                  </div>
                  <div>
                    <div className="text-white text-sm font-semibold whitespace-nowrap">正在热播</div>
                    <div className="text-white/60 text-xs">《庆余年第二季》</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}